"use client";

import * as React from "react";
import { Check, ChevronsUpDown } from "lucide-react";

import { cn } from "src/lib/utils";
import { Button } from "src/Components/ui/button";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "src/Components/ui/command";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/Components/ui/popover";
import { useTranslation } from "react-i18next";

export function Combobox(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false);
  const triggerRef = React.useRef(null);
  const [width, setWidth] = React.useState("auto");

  // fallback to 'id' if no idKey prop provided
  const idKey = props.idKey || "id";

  React.useEffect(() => {
    if (triggerRef.current && open) {
      setWidth(`${triggerRef.current.offsetWidth}px`);
    }
  }, [open]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          ref={triggerRef}
          variant="outline"
          role="combobox"
          aria-expanded={open}
          className="w-full justify-between"
        >
          {props.value
            ? props.data &&
              props.data.find((row) => row[idKey] === props.value)?.[props.lable]
            : props.placeholder}
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0" align="start" style={{ width }}>
        <Command>
          <CommandInput placeholder={t("gloabl.search") + "..."} />
          <CommandList>
            <CommandEmpty>{t("errorMessage.noData")}</CommandEmpty>
            <CommandGroup>
              {props.data &&
                props.data.map((row) => (
                  <CommandItem
                    className="cursor-pointer"
                    key={row[idKey]}
                    value={row[idKey]}
                    onSelect={() => {
                      props.onChange(row[idKey]);
                      setOpen(false);
                    }}
                  >
                    <Check
                      className={cn(
                        "mr-2 h-4 w-4",
                        props.value === row[idKey] ? "opacity-100" : "opacity-0"
                      )}
                    />
                    {row[props.lable]}
                  </CommandItem>
                ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
